module.exports = __webpack_public_path__ + "img/pic4_bg_hover.c591f60.webp";